const ONE_DECIMAL_FACTOR = 10;
const WHOLE_NUMBER_THRESHOLD_PERCENT = 10;

export const getDisplayCompletionPercentage = (
  completionCount: number,
  target: number,
): number => {
  const percentage =
    Math.round(
      (completionCount / Math.max(1, target)) * 100 * ONE_DECIMAL_FACTOR,
    ) / ONE_DECIMAL_FACTOR;
  return percentage >= WHOLE_NUMBER_THRESHOLD_PERCENT
    ? Math.round(percentage)
    : percentage;
};
